import styled from 'styled-components'

export const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 100px;
  border: 1px solid #ebebeb;
  background-color: #ebebeb;
  padding: 0 15px;
  width: 100%;
  height: 40px;
  min-height: 40px;
  box-sizing: border-box;
  padding-right: 38px;
  position: relative;
`

export const FileUploadLabel = styled.label`
  && {
    background-color: #fff;
    border-radius: 4px;
    padding: 0 10px;
    height: 24px;
    min-height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    line-height: 1;
    cursor: pointer;
    margin: 0 8px 0 0;
    white-space: nowrap;
    font-size: 0.8rem;
    font-weight: 700;
  }
`

export const FileNameText = styled.span`
  color: #666;
  font-size: 0.8rem;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`

export const ExistingAttachmentGrid = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`

export const ExistingAttachmentCard = styled.div`
  width: 84px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  position: relative;
`

export const ExistingAttachmentPreview = styled.div`
  width: 74px;
  height: 74px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  position: relative;
  cursor: pointer;
  padding: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
`

export const ExistingAttachmentName = styled.span`
  font-size: 11px;
  color: #666;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ExistingAttachmentFileBadge = styled.span`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
`

export const ExistingAttachmentMenuButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e0e0e0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #666;
`

export const ExistingAttachmentDropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: auto;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 10003;
  min-width: 170px;
  overflow: hidden;
`

export const ExistingAttachmentDropdownPortal = styled.div`
  position: fixed;
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 2147483647;
  width: fit-content;
  min-width: fit-content;
  max-width: calc(100vw - 20px);
  overflow: hidden;
  animation: fadeIn 0.15s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const ExistingAttachmentDropdownItem = styled.button`
  display: block;
  width: 100%;
  border: none;
  background: #fff;
  text-align: left;
  padding: 9px 12px;
  font-size: 13px;
  color: #303030;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
  }

  &.danger {
    color: #ef4444;
  }

  &.danger:hover {
    background: #fef2f2;
  }
`

export const AttachmentListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
`

export const AttachmentListRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: #e8f5e9;
  border-radius: 8px;
  font-size: 13px;
  color: #303030;
  min-height: 40px;
  box-sizing: border-box;
`

export const AttachmentListName = styled.span`
  flex: 1;
  word-break: break-word;
  margin-right: 10px;
`

export const AttachmentListActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`

export const AttachmentListLinkButton = styled.button`
  border: none;
  background: transparent;
  color: #0090d3;
  cursor: pointer;
  padding: 0;
  font-size: 13px;
`

export const AttachmentListIconButton = styled.button`
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const ExistingAttachmentCoverTag = styled.span`
  position: absolute;
  left: 4px;
  bottom: 4px;
  background: rgba(0, 144, 211, 0.92);
  color: #fff;
  border-radius: 5px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 700;
`
